import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export interface PaddedContentProps {
  scroll?: boolean
  className?: string
  style?: React.CSSProperties
}

const PADDED_CONTENT_STYLES =
  'px-4 md:px-12 xl:px-18 py-2 md:py-4 lg:py-8 flex flex-col w-full bg-contentareabackground'
const SCROLL_STYLES = 'h-full overflow-y-scroll'

export const PaddedContent: React.FC<PropsWithChildren<PaddedContentProps>> = ({
  children,
  className,
  scroll,
  style,
}) => (
  <div
    style={style}
    className={concatStyles([
      PADDED_CONTENT_STYLES,
      scroll ? SCROLL_STYLES : '',
      className,
    ])}
  >
    {children}
  </div>
)

PaddedContent.displayName = 'Layout.PaddedContent'
